import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  ListSubheader,
} from "@mui/material";

const styles = () => {
  return {
    borderColor: "#102d39",
    "& .MuiInputBase-input": {
      "&:focus": {
        borderColor: "#102d39",
      },
    },
    "& .gsInputLabel": {
      fontSize: "13px",
    },
    "& .gsSelect": {
      color: "#102d39",
      fontSize: "13px",
      "& .MuiSelect-icon": {
        color: "#102d39",
        fontSize: "26px",
        marginRight: "5px",
      },
    },
    "& .gsMenuItem": {
      fontSize: "13px",
      color: "#102d39",
    },
    "& .gsListSubheader": {
      fontSize: "14px",
      color: "#102d39",
      padding: "4px 8px 0 !important",
      lineHeight: "30px",
      borderTop: "1px solid #eaeaea",
    },
  };
};

const GroupedSelect = (props) => {
  function renderSelectGroup(group) {
    const items = group.data.map((item, index) => {
      return (
        <MenuItem key={props.name + index} className="gsMenuItem" value={item.value}>
          {item.label}
        </MenuItem>
      );
    });
    return [
      <ListSubheader className="gsListSubheader">{group.name}</ListSubheader>,
      items,
    ];
  }

  return (
    <FormControl
      fullWidth
      disabled={props.disabled}
      error={props.error ? true : false}
      sx={styles()}
      variant="filled"
    >
      <InputLabel className="gsInputLabel" shrink id={props.name + "-label"}>
        {props.label}
      </InputLabel>
      <Select
        displayEmpty
        disableUnderline={props.disabled}
        autoWidth={false}
        labelId={props.name + "-label"}
        name={props.name}
        id={props.name}
        value={props.value}
        onChange={props.onChange}
        IconComponent={props.IconComponent}
        className="gsSelect"
        disabled={props.disabled}
      >
        <MenuItem value="" disabled className="gsMenuItem">
          <em>Please select</em>
        </MenuItem>
        {props.options?.map((group) => renderSelectGroup(group))}
      </Select>
      {props.error && props.helperText ? (
        <FormHelperText>{props.helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default GroupedSelect;
